import MissingLogs from './MissingLogs';

export default MissingLogs;
